/**
 * Defers ResizeObserver callbacks until the next frame.
 *
 * Layout changes made directly from a ResizeObserver callback can trigger
 * another notification during the same browser layout pass. Keeping this
 * scheduling in one place prevents that loop across all components.
 */
export const createRafResizeObserver = (callback) => {
  let frameId = null;
  let pendingEntries = [];
  const observer = new ResizeObserver((entries) => {
    pendingEntries = entries;
    if (frameId !== null) {
      return;
    }

    frameId = window.requestAnimationFrame(() => {
      frameId = null;
      const entriesToProcess = pendingEntries;
      pendingEntries = [];
      callback(entriesToProcess);
    });
  });

  const disconnect = observer.disconnect.bind(observer);
  observer.disconnect = () => {
    disconnect();
    if (frameId !== null) {
      window.cancelAnimationFrame(frameId);
      frameId = null;
    }
    pendingEntries = [];
  };

  return observer;
};
